import React, { useState } from 'react';

const StoreReportGuide = () => {
  const [activeTabId, setActiveTabId] = useState<string | null>(null);

  const handleTabClick = (tabId: string) => {
    setActiveTabId((prevTabId) => (prevTabId === tabId ? null : tabId));
  };

  const guideTabData = [
    {
      id: 'tab1',
      label: '매장리포트 가이드',
      content: (
        <div className="guideWrap">
          <div>
            <h3>온보딩 완료일</h3>
            <p>포스 로그인과 호텔 광고 등록이 모두 완료된 일자</p>
          </div>
          <div>
            <h3>실제 운영한 영업시간</h3>
            <p>등록영업시간 내 포스 로그인 등이 정상적으로 이뤄진 영업시간의 총합</p>
          </div>
          <div>
            <h3>등록된 영업시간</h3>
            <p>매장이 등록한 영업시간의 총합</p>
          </div>
          <div>
            <h3>정상 운영 비율 계산 방식</h3>
            <p>실제 영업시간/등록 영업시간 * 100 (%)</p>
          </div>
          <div>
            <h3>총주문건수</h3>
            <p>해당 매장에 요청된 총 주문 건수</p>
          </div>
          <div>
            <h3>배달완료주문건수</h3>
            <p>배달이 완료된 주문 건수</p>
          </div>
          <div>
            <h3>주문수행률 계산 방식</h3>
            <p>배달완료주문건수/총주문건수 * 100 (%)</p>
          </div>
          <div>
            <h3>주문지연알림건수</h3>
            <p>60초이상 주문 지연이 발생한 건수</p>
          </div>
          <div>
            <h3>주문 거절 건수</h3>
            <p>자동으로 취소된 주문 건수를 포함한 주문 거절 건수</p>
          </div>
          <div>
            <h3>접수평균시간</h3>
            <p>'주문 접수'가 이뤄진 평균 소요 시간</p>
          </div>
          <div>
            <h3>조리완료수행률</h3>
            <p>[배달 완료]된 주문 중, [조리 완료]를 수행한 주문의 비율</p>
          </div>
          <div>
            <h3>(A)인센티브 지급 계산 방식</h3>
            <p>(최종결제금액 - 배달팁 - 객실관리팁) * 6.8% * 20%</p>
          </div>
        </div>
      ),
    },
    {
      id: 'tab2',
      label: '성과급 지급 기준 및 조건',
      content: (
        <div className="guideWrap">
          <h3>성과급 지급 거절 사유</h3>
          <p>
            비정상영업매장, 주문수행미흡매장에 한가지라도 해당되는 매장 중 성과급 미지급 예외규정을
            충족하지 못한 매장.
          </p>
          <h3>1. 비정상영업매장</h3>
          <p>정상운영비율이 70% 이하이고 실제영업시간이 150시간 미만</p>
          <h3>2. 주문수행미흡매장</h3>
          <p>배달완료율이 70% 이하</p>
          <h3>3. 성과급 미지급 예외규정 조건</h3>

          <p>(1) 당사 시스템 오류</p>
          <p>(2) 기상악화로 다수 주문 취소 발생 시 해당 날 제외</p>
          <p>
            (3)배달완료주문건수 10건 이상이며, 주문수행률 60%이상이며, 정상영업비율이 50%이상인 매장
            (세가지 모두 충족)
          </p>
          <p>(4) 기타 당사의 귀책 사유 발생 시</p>

          <h3>*입점대행료 지급 기준</h3>
          <p>1. 매장기준일의 익월 리포트에서 정산</p>
          <p>2. 성과급 지급 기준 충족 시 최초 1회 지급</p>
          <p>
            3. 매장기준일의 익월, 익익월 리포트에서 성과급 지급 기준 미충족 시 모든 성과급 지급
            불가.
            <br />
            <em>
              예) 매장기준일: 2024-01-28 → 2024년 2월, 3월 리포트에서 성과급 지급 기준 미충족 시
              모든 성과급 지급 불가.
            </em>
          </p>
          <h3>*유지장려금 지급 기준</h3>
          <p>
            유지장려금1: 입점대행료 지급 익월 리포트에서 성과급 지급 기준 충족 시 최초 1회 지급.
          </p>
          <p>
            유지장려금2: 유지장려금1 지급 익월 리포트에서 성과급 지급 기준 충족 시 최초 1회 지급.
          </p>
          <p>
            유지장려금3: 유지장려금2 지급 익월 리포트에서 성과급 지급 기준 충족 시 최초 1회 지급.
          </p>
          <p>유지장려금은 입점대행료 지급 익월부터 5개월 내 기준 충족을 못할 시 소멸됨. </p>
          <p>
            <em>예) 매장기준일: 2024-01-28 → 2024년 7월 리포트 까지 유효함 이후 지급 불가.</em>
          </p>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div>
        {guideTabData.map((tab) => (
          <button key={tab.id} onClick={() => handleTabClick(tab.id)}>
            {tab.label}
          </button>
        ))}
      </div>
      <div>{activeTabId && guideTabData.find((tab) => tab.id === activeTabId)?.content}</div>
    </div>
  );
};

export default StoreReportGuide;
